export enum DownTimeTrackingStatusEnum{
    OPEN='OPEN',
    WIP='WIP',
    PENDING='PENDING',
    CLOSE='CLOSE',
    CANCEL='CANCEL',
    WAITING_ON_VENDOR='WATING ON VENDOR'
}